import { createContext, useContext } from 'react'

export type FlagVariation = (flagName: string, defaultValue: any) => any

interface FlagContextValues {
  variation: FlagVariation
}

export const FlagContext = createContext<FlagContextValues>({
  variation: (flagName: string, defaultValue: any): any => defaultValue,
})

export const useFlagContextValue = (): FlagContextValues => {
  const context = useContext(FlagContext)

  return context
}
